import {
  AntDesign,
  MaterialCommunityIcons,
  MaterialIcons,
  Octicons,
} from "@expo/vector-icons";
import { router } from "expo-router";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { View, Text } from "react-native";
import { useDispatch } from "react-redux";

import Logo from "@/assets/logo.svg";
import ButtonLogout from "@/components/button/ButtonLogout";
import Item from "@/components/menu/Item";
import { setForm } from "@/context/actions/actions";
import { useAppSelector } from "@/context/hooks";

interface DashboardMenuProps {
  name?: string;
  selectedItem?: string;
  onItemSelected?: (item: string) => void;
}

export default function DashboardMenu(props: DashboardMenuProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = useState(
    t("management/home:menu.customers")
  );
  const globalValues = useAppSelector((state: any) => state);

  useEffect(() => {
    setSelectedItem(globalValues.currentMenuItem);
  }, [globalValues.currentMenuItem]);

  const handleSelectedItem = (title: string) => {
    dispatch(setForm({ itemSelected: title }));
    setSelectedItem(title);
    switch (title) {
      case t("management/home:menu.customers"):
        router.push("/management/dashboard");
        break;
      case t("management/home:menu.transactions"):
        router.push("/management/transactions");
        break;
      case t("management/home:menu.counterparties"):
        router.push("/management/counterparties");
        break;
      case t("management/home:menu.applications"):
        router.push("/management/applications");
        break;
    }
  };

  return (
    <View className="flex-col h-full w-fit justify-between py-4 px-3 shadow">
      <View className="items-center">
        <View className="my-2">
          <Logo height={60} width={100} />
        </View>
        <View className="w-full my-2 items-center">
          <Text className="text-xl">{t("management/home:menu.title")}</Text>
        </View>
        <Item
          title={t("management/home:menu.customers")}
          icon={<MaterialIcons name="people-outline" />}
          onPress={(title) => handleSelectedItem(title)}
          isSelected={selectedItem}
        />
        <Item
          title={t("management/home:menu.transactions")}
          icon={<MaterialIcons name="attach-money" />}
          onPress={(title) => handleSelectedItem(title)}
          isSelected={selectedItem}
        />
        <Item
          title={t("management/home:menu.counterparties")}
          icon={<Octicons name="arrow-switch" />}
          onPress={(title) => handleSelectedItem(title)}
          isSelected={selectedItem}
        />
        <Item
          title={t("management/home:menu.applications")}
          icon={<MaterialCommunityIcons name="file-document-outline" />}
          onPress={(title) => handleSelectedItem(title)}
          isSelected={selectedItem}
        />
      </View>
      <View className="items-center m-2">
        <ButtonLogout />
      </View>
    </View>
  );
}
